<template>
  <div class="share-preview-container">
    <!-- 顶部菜单 -->
    <div class="top_menu">
      <div class="title" style="background: #F5F6F7">
        <img src="@/assets/logo.png" class="logo" alt="logo" />
        <span>瑞银文件管理系统 - 文件分享</span>
      </div>
      <div class="zoom-controls">
        <div class="zoom-label">
          <i class="el-icon-zoom-in"></i>
          <span>缩放</span>
        </div>
        <el-button-group>
          <el-button size="small" icon="el-icon-minus" @click="zoomOut" :disabled="iframeZoom <= 10"></el-button>
          <el-button size="small" @click="resetZoom">{{ iframeZoom }}%</el-button>
          <el-button size="small" icon="el-icon-plus" @click="zoomIn" :disabled="iframeZoom >= 200"></el-button>
        </el-button-group>
      </div>
      <ul>
        <li v-if="isLoggedIned">
          <user-pull-down>
            <span>{{ userName }}<i class="el-icon-arrow-down el-icon--right"></i></span>
          </user-pull-down>
        </li>
        <li v-else>
          <el-button type="primary" size="small" @click="goToLogin">登录查看</el-button>
        </li>
      </ul>
    </div>

    <!-- 未登录提示 -->
    <div v-if="!isLoggedIned" class="login-required-container">
      <el-result icon="warning" title="需要登录" subTitle="请先登录后才能查看分享的文件">
        <template slot="extra">
          <el-button type="primary" size="medium" @click="goToLogin">
            <i class="el-icon-user"></i> 立即登录
          </el-button>
        </template>
      </el-result>
    </div>

    <!-- 文件预览区域（仅登录后显示） -->
    <div v-else class="preview-wrapper" v-loading="loading">
      <div v-if="error" class="error-container">
        <div class="error-card">
          <div class="error-icon-wrap">
            <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="60" cy="60" r="56" stroke="#EBEEF5" stroke-width="8"/>
              <path d="M38 44C38 40.686 40.686 38 44 38H64L82 56V76C82 79.314 79.314 82 76 82H44C40.686 82 38 79.314 38 76V44Z" fill="#F0F4FF" stroke="#C0CCDA" stroke-width="2"/>
              <path d="M64 38V56H82" stroke="#C0CCDA" stroke-width="2" stroke-linecap="round"/>
              <rect x="48" y="64" width="24" height="2.5" rx="1.25" fill="#C0CCDA"/>
              <rect x="48" y="70" width="16" height="2.5" rx="1.25" fill="#C0CCDA"/>
              <circle cx="84" cy="84" r="16" fill="#FF6B6B"/>
              <path d="M80 80L88 88M88 80L80 88" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="error-title">无法访问该文件</div>
          <div class="error-desc">{{ errorMsg }}</div>
          <div class="error-actions">
            <el-button type="primary" plain size="small" icon="el-icon-refresh" @click="loadFileInfo">重新加载</el-button>
            <el-button size="small" icon="el-icon-arrow-left" @click="nav()">返回主页</el-button>
          </div>
        </div>
      </div>

      <div v-else-if="fileInfo" class="file-preview">
        <!-- 文件信息头部 -->
        <!-- <div class="file-header">
          <div class="file-info">
            <i class="el-icon-document" style="color: #409eff; font-size: 24px; margin-right: 12px;"></i>
            <div>
              <div class="file-name">{{ fileInfo.fileName }}</div>
              <div class="file-meta">
                <span><i class="el-icon-user"></i> {{ fileInfo.createUser }}</span>
                <span><i class="el-icon-time"></i> {{ fileInfo.createDate }}</span>
               </div>
            </div>
          </div>
          <div class="file-actions">
            <el-button type="primary" icon="el-icon-download" @click="downloadFile">下载文件</el-button>
          </div>
        </div> -->

        <!-- 文件预览内容 -->
        <div class="preview-content">
          <div v-if="!isSupportPreview()" class="preview-unsupported">
            <el-result icon="warning" title="不支持预览" subTitle="该文件类型暂不支持在线预览">
              <!-- <template slot="extra">
                <el-button type="primary" size="small" @click="downloadFile">下载文件</el-button>
              </template> -->
            </el-result>
          </div>
          <iframe v-else :key="previewKey" :src="getPreviewUrl()" frameborder="0" class="preview-iframe"
            :style="{ transform: `scale(${iframeZoom / 100})`, transformOrigin: 'top left', width: `${10000 / iframeZoom}%`, height: `${10000 / iframeZoom}%` }"
            @load="onPreviewLoad" @error="onPreviewError">
          </iframe>
        </div>
      </div>

      <div v-else class="loading-container">
        <el-empty description="加载中..."></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import * as c from '@/utils/config'
import * as u from '@/utils/util'

export default {
  name: "sharePreview",
  components: {
    'user-pull-down': () => import('@/components/auth/userPullDown.vue'),
  },
  data() {
    return {
      fileId: '',
      fileInfo: null,
      loading: false,
      error: false,
      errorMsg: '',
      previewKey: 0,
      isLoggedIn: false,
      userName: '',
      //当前查看文件的开始时间
      currentViewStartTime: null,
      //iframe缩放比例
      iframeZoom: 100,
    }
  },
  created() {
    console.log('=== sharePreview created 钩子执行 ===');
    console.log('完整 URL:', window.location.href);
    console.log('路由参数:', this.$route.query);
    
    // 从路由参数获取文件ID
    this.fileId = this.$route.query.fileId;
    console.log('文件ID:', this.fileId);
    
    if (!this.fileId) {
      this.error = true;
      this.errorMsg = '缺少文件ID参数';
      this.loading = false;
      return;
    }

    // 从路由参数获取 token（如果有）
    const urlToken = this.$route.query.token;
    console.log('URL 中的 token:', urlToken ? '存在' : '不存在');
    
    if (urlToken) {
      console.log('从 URL 获取到 token，保存到本地');
      console.log('Token 前10个字符:', urlToken.substring(0, 10) + '...');
      // 保存 token 到本地存储
      u.setToken(urlToken);
      console.log('Token 保存完成，验证是否保存成功:', u.getToken() ? '成功' : '失败');
      // 设置登录状态
      this.$store.commit('SET_LOGIN_STATE', true);
    }

    // 检查登录状态并加载文件
    this.checkLoginStatus();
  },
  mounted() {
    // 监听路由变化，当从登录页返回时重新检查登录状态
    this.$watch('$route', () => {
      this.checkLoginStatus();
    });

    // 监听页面离开事件，记录结束时间
    window.addEventListener('beforeunload', this.recordViewEndTime);
    
    // 监听页面可见性变化（切换标签页）
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  activated() {
    // 如果使用了 keep-alive，在组件激活时也检查登录状态
    this.checkLoginStatus();
  },
  beforeDestroy() {
    // 组件销毁前记录结束时间
    this.recordViewEndTime();
    // 移除事件监听
    window.removeEventListener('beforeunload', this.recordViewEndTime);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: 
  {
    nav(){
      this.$router.push({ path: "/file/myFileTree" })
    },
    /**
     * 放大iframe
     */
    zoomIn() {
      if (this.iframeZoom < 200) {
        this.iframeZoom += 10;
      }
    },

    /**
     * 缩小iframe
     */
    zoomOut() {
      if (this.iframeZoom > 10) {
        this.iframeZoom -= 10;
      }
    },

    /**
     * 重置缩放
     */
    resetZoom() {
      this.iframeZoom = 100;
    },

    /**
     * 检查登录状态
     */
    checkLoginStatus() {
      const token = u.getToken();
      const userInfo = u.getSession(c.sessionKey.USER_INFO);

      console.log('=== 分享页面：检查登录状态 ===');
      console.log('Token:', token);
      console.log('UserInfo:', userInfo);
      console.log('sessionKey.USER_INFO:', c.sessionKey.USER_INFO);

      if (token) {
        // 有 token 就认为已登录（分享页面不需要完整的用户信息）
        this.isLoggedIned = true;
        
        // 如果有用户信息，使用用户信息中的名称
        if (userInfo) {
          this.userName = userInfo.name || userInfo.username || '用户';
        } else {
          // 如果没有用户信息，显示默认名称
          this.userName = '访客';
        }
        
        console.log('✅ 已登录，用户名:', this.userName);
        console.log('开始加载文件信息...');
        // 已登录，直接加载文件信息
        this.loadFileInfo();
      } else {
        // 未登录
        this.isLoggedIned = false;
        this.userName = '';
        this.loading = false;
        console.log('❌ 未登录，显示登录提示');
      }
    },

    /**
     * 跳转到登录页，登录后返回当前页面
     */
    goToLogin() {
      // 保存当前路由，登录后跳转回来
      const currentPath = this.$route.fullPath;
      this.$router.push({
        path: '/login',
        query: { redirect: currentPath }
      });
    },

    /**
     * 加载文件信息（需要登录）
     */
    loadFileInfo() {
      if (!this.isLoggedIned) {
        return;
      }

      this.loading = true;
      this.error = false;

      this.$HttpService.post(`/file-info/detail`, { id: this.fileId }).then(async res => {
        if (!res || !res.fileId) {
          this.error = true;
          this.errorMsg = '文件不存在或您没有查看该文件的权限';
          this.loading = false;
          return;
        }
        this.fileInfo = res;

        // 预检预览接口是否可访问（防止 iframe 内显示 JSON 错误信息）
        await this.checkPreviewAccess();

        this.loading = false;
        if (!this.error) {
          this.recordViewStartTime();
        }
      }).catch(err => {
        this.error = true;
        this.errorMsg = '文件信息加载失败，请检查链接是否正确';
        this.loading = false;
      });
    },

    /**
     * 预检预览接口是否可正常访问
     * 针对 viewNewFile / viewFileByWindow 返回 JSON 错误的情况
     */
    async checkPreviewAccess() {
      const previewUrl = this.getPreviewUrl();
      if (!previewUrl) return;
      try {
        const resp = await fetch(previewUrl, { method: 'GET' });
        const contentType = resp.headers.get('content-type') || '';
        // 如果返回的是 JSON，说明接口报错（正常文件流不会是 JSON）
        if (contentType.includes('application/json')) {
          const json = await resp.json();
          if (json && (json.code === 0 || json.code === 400 || json.code === 403)) {
            this.error = true;
            this.errorMsg = json.msg || '文件不存在或您没有查看该文件的权限';
          }
        }
      } catch (e) {
        // 跨域或网络错误时忽略，由 iframe 的 onPreviewError 兜底
      }
    },

    /**
     * 判断文件是否支持预览
     */
    isSupportPreview() {
      if (!this.fileInfo || !this.fileInfo.fileType) {
        return false;
      }
      const fileType = this.fileInfo.fileType;
      return c.supportFile.view.indexOf(fileType) !== -1 ||
        c.supportFile.windowView.indexOf(fileType) !== -1;
    },

    /**
     * 获取预览URL
     */
    getPreviewUrl() {
      if (!this.fileInfo || !this.fileInfo.fileId) {
        return "";
      }
      const fileInfo = this.fileInfo;
      const token = u.getToken();
      const base = c.system.apiUrl;

      // 浏览器可直接预览的文件类型（PDF、图片等）
      if (c.supportFile.windowView.indexOf(fileInfo.fileType) !== -1) {
        return `${base}/file-info/viewFileByWindow/${fileInfo.fileId}?token=${token}`;
      }

      // OnlyOffice 预览的文件类型（Word、Excel、PPT等）
      if (c.supportFile.view.indexOf(fileInfo.fileType) !== -1) {
        return `${base}/file-info/viewNewFile/${fileInfo.originalFileId}?token=${token}`;
      }

      return "";
    },

    /**
     * 下载文件
     */
    async downloadFile() {
      if (!this.fileInfo || !this.fileInfo.fileId) {
        return;
      }
      try {
        const downloadUrl = u.getUrlAll(`/file-info/download/${this.fileInfo.fileId}`);

        // 直接使用 window.location 下载
        window.location.href = downloadUrl;

        this.$message.success('开始下载文件');
      } catch (error) {
        console.error('下载文件失败:', error);
        this.$message.error('文件下载失败');
      }
    },

    /**
     * 预览加载完成
     */
    onPreviewLoad() {
      this.loading = false;
    },

    /**
     * 预览加载错误
     */
    onPreviewError() {
      this.error = true;
      this.errorMsg = '文件预览加载失败';
      this.loading = false;
    },

    /**
     * 格式化文件大小
     */
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    },

    /**
     * 记录查看文件开始时间
     */
    recordViewStartTime() {
      if (!this.fileInfo || !this.fileInfo.fileId) {
        return;
      }

      const userInfo = u.getSession(c.sessionKey.USER_INFO);
      if (!userInfo) {
        return;
      }

      // 格式化当前时间为 yyyy-MM-dd HH:mm:ss
      const now = new Date();
      this.currentViewStartTime = this.formatDateTime(now);

      // 调用接口记录开始时间
      this.$HttpService.post('/file-view/insert', {
        fileId: this.fileInfo.fileId,
        type: 1, // 1-查看
        username: userInfo.username || userInfo.name,
        startTime: this.currentViewStartTime
      }).then(() => {
        console.log('记录查看开始时间成功:', this.currentViewStartTime);
      }).catch(err => {
        console.error('记录查看开始时间失败:', err);
      });
    },

    /**
     * 记录查看文件结束时间
     */
    recordViewEndTime() {
      if (!this.fileInfo || !this.fileInfo.fileId || !this.currentViewStartTime) {
        return;
      }

      const userInfo = u.getSession(c.sessionKey.USER_INFO);
      if (!userInfo) {
        return;
      }

      // 调用接口记录结束时间
      this.$HttpService.post('/file-view/updateEndTime', {
        fileId: this.fileInfo.fileId,
        type: 1, // 1-查看
        username: userInfo.username || userInfo.name,
        startTime: this.currentViewStartTime
      }).then(() => {
        console.log('记录查看结束时间成功');
        this.currentViewStartTime = null;
      }).catch(err => {
        console.error('记录查看结束时间失败:', err);
      });
    },

    /**
     * 格式化日期时间为 yyyy-MM-dd HH:mm:ss
     */
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    /**
     * 处理页面可见性变化（切换标签页）
     */
    handleVisibilityChange() {
      if (document.hidden) {
        // 页面被隐藏（切换到其他标签页），记录结束时间
        console.log('页面被隐藏，记录查看结束时间');
        this.recordViewEndTime();
      } else {
        // 页面重新可见（切换回当前标签页），记录新的开始时间
        console.log('页面重新可见，记录新的查看开始时间');
        if (this.fileInfo && this.fileInfo.fileId) {
          this.recordViewStartTime();
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">
.share-preview-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;

  // 缩放控制样式
  .zoom-controls {
    display: flex;
    align-items: center;
    gap: 12px;

    .zoom-label {
      display: flex;
      align-items: center;
      color: #6f7588;
      font-size: 14px;
      gap: 5px;

      i {
        font-size: 16px;
        color: #1e6fff;
      }
    }

    .el-button-group {
      display: flex;

      .el-button {
        padding: 7px 12px;
        font-size: 12px;

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }

  .top_menu {
    width: 100%;
    height: 50px;
    display: flex;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);

    .logo {
      height: 40px;
      margin-top: 5px;
      vertical-align: top;
      margin-right: 8px;
    }

    .title {
      width: 300px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      font-size: 16px;
      color: #363b4c;
      font-weight: 600;
    }

    ul {
      flex: 1;
      width: 100%;
      height: 100%;
      padding: 0 20px;
      color: #363b4c;
      list-style-type: none;
      text-align: right;
      margin: 0;

      li {
        line-height: 50px;
        display: inline-block;
        margin-left: 20px;
      }
    }
  }

  .login-required-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
  }

  .preview-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .error-container,
    .loading-container {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f7f8fc;
    }

    .error-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
      padding: 48px 56px;
      max-width: 420px;
      width: 90%;
      text-align: center;

      .error-icon-wrap {
        width: 120px;
        height: 120px;
        margin-bottom: 28px;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      .error-title {
        font-size: 20px;
        font-weight: 700;
        color: #303133;
        margin-bottom: 10px;
        letter-spacing: 0.5px;
      }

      .error-desc {
        font-size: 14px;
        color: #909399;
        line-height: 1.7;
        margin-bottom: 32px;
        padding: 0 8px;
      }

      .error-actions {
        display: flex;
        gap: 12px;
        justify-content: center;
        flex-wrap: wrap;
      }
    }

    .file-preview {
      flex: 1;
      display: flex;
      flex-direction: column;
      background: #fff;

      .file-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        border-bottom: 1px solid #e0e0e0;
        background: #fafafa;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

        .file-info {
          display: flex;
          align-items: center;
          flex: 1;

          .file-name {
            font-size: 18px;
            font-weight: 600;
            color: #303133;
            margin-bottom: 8px;
          }

          .file-meta {
            display: flex;
            gap: 20px;
            font-size: 13px;
            color: #909399;

            span {
              display: flex;
              align-items: center;
              gap: 4px;

              i {
                font-size: 14px;
              }
            }
          }
        }

        .file-actions {
          display: flex;
          gap: 10px;
        }
      }

      .preview-content {
        flex: 1;
        position: relative;
        overflow: hidden;

        .preview-iframe {
          width: 100%;
          height: 100%;
          border: none;
          background: #fff;
        }

        .preview-unsupported {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  // ==================== 移动端适配 ====================
  @media screen and (max-width: 768px) {
    .top_menu {
      height: auto;
      min-height: 50px;
      flex-wrap: wrap;
      padding: 8px 0;

      .logo {
        height: 32px;
        margin-top: 0;
        margin-right: 6px;
      }

      .title {
        width: auto;
        flex: 1;
        padding-left: 12px;
        font-size: 14px;
        
        span {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .zoom-controls {
        display: none; // 移动端隐藏缩放控制
      }

      ul {
        padding: 0 12px;
        
        li {
          line-height: 40px;
          margin-left: 10px;
          
          .el-button {
            padding: 8px 12px;
            font-size: 13px;
          }
        }
      }
    }

    .login-required-container {
      padding: 20px;
      
      ::v-deep .el-result {
        padding: 20px 0;
        
        .el-result__icon {
          font-size: 48px;
          
          svg {
            width: 48px;
            height: 48px;
          }
        }
        
        .el-result__title {
          font-size: 16px;
          margin-top: 12px;
        }
        
        .el-result__subtitle {
          font-size: 13px;
          margin-top: 8px;
        }
        
        .el-result__extra {
          margin-top: 20px;
          
          .el-button {
            padding: 10px 20px;
            font-size: 14px;
          }
        }
      }
    }

    .preview-wrapper {
      .error-container,
      .loading-container {
        padding: 20px;
        
        ::v-deep .el-result {
          padding: 20px 0;
          
          .el-result__icon {
            font-size: 48px;
          }
          
          .el-result__title {
            font-size: 16px;
          }
          
          .el-result__subtitle {
            font-size: 13px;
          }
        }
        
        ::v-deep .el-empty {
          padding: 20px 0;
          
          .el-empty__image {
            width: 120px;
          }
          
          .el-empty__description {
            font-size: 13px;
          }
        }
      }

      .file-preview {
        .file-header {
          flex-direction: column;
          align-items: flex-start;
          padding: 12px 16px;
          gap: 12px;

          .file-info {
            width: 100%;
            
            i {
              font-size: 20px !important;
              margin-right: 8px !important;
            }

            .file-name {
              font-size: 15px;
              margin-bottom: 6px;
              word-break: break-all;
            }

            .file-meta {
              flex-direction: column;
              gap: 6px;
              font-size: 12px;
            }
          }

          .file-actions {
            width: 100%;
            
            .el-button {
              flex: 1;
              padding: 10px 16px;
              font-size: 13px;
            }
          }
        }

        .preview-content {
          .preview-iframe {
            // 移动端禁用缩放变换，使用原始大小
            transform: none !important;
            width: 100% !important;
            height: 100% !important;
          }

          .preview-unsupported {
            padding: 20px;
            
            ::v-deep .el-result {
              .el-result__icon {
                font-size: 48px;
              }
              
              .el-result__title {
                font-size: 16px;
              }
              
              .el-result__subtitle {
                font-size: 13px;
              }
              
              .el-result__extra {
                .el-button {
                  padding: 10px 20px;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }

  // 小屏幕手机适配（宽度小于 480px）
  @media screen and (max-width: 480px) {
    .top_menu {
      .title {
        font-size: 12px;
        padding-left: 8px;
        
        .logo {
          height: 28px;
          margin-right: 4px;
        }
      }

      ul {
        padding: 0 8px;
        
        li {
          margin-left: 6px;
          
          .el-button {
            padding: 6px 10px;
            font-size: 12px;
          }
          
          span {
            font-size: 13px;
          }
        }
      }
    }

    .login-required-container {
      padding: 16px;
    }

    .preview-wrapper {
      .file-preview {
        .file-header {
          padding: 10px 12px;
          
          .file-info {
            .file-name {
              font-size: 14px;
            }
            
            .file-meta {
              font-size: 11px;
            }
          }
        }
      }
    }
  }

  // 横屏适配
  @media screen and (max-width: 768px) and (orientation: landscape) {
    .top_menu {
      min-height: 44px;
      
      .title {
        font-size: 13px;
      }
      
      ul li {
        line-height: 44px;
      }
    }

    .preview-wrapper {
      .file-preview {
        .file-header {
          flex-direction: row;
          align-items: center;
          padding: 8px 12px;
          
          .file-info {
            width: auto;
            flex: 1;
            
            .file-name {
              margin-bottom: 4px;
            }
            
            .file-meta {
              flex-direction: row;
              gap: 12px;
            }
          }
          
          .file-actions {
            width: auto;
            
            .el-button {
              flex: none;
            }
          }
        }
      }
    }
  }
}
</style>
